import { enumVersionPublicationStatus } from '@ingenico/api-sdk-device-management-private';
import type {
  BffSystemPackageVersionResourceReadV2Api,
  ComponentVersionDependencyMetadataApi,
  SystemPackageResourceReadV2Api,
} from '@ingenico/api-sdk-device-management-private-v2';
import { isEqual, toArray, toString } from 'lodash-es';
import type {
  BffSystemPackageVersionByIdFront,
  OverViewPayloadDTO,
  VersionDTO,
} from '../../../components/overview-tab/Overviewtab.model';
import { toIsoStringIfDate } from '../utils/date.utils';

export function mapSystemPackageById({
  name,
  status,
  assets,
  longDescription,
  shortDescription,
  compatibleDeviceFamilyNames,
  creationDate,
  id,
  systemPackageVersions,
}: SystemPackageResourceReadV2Api): Omit<
  OverViewPayloadDTO,
  'latestVersion' | 'latestVersionId' | 'markdown' | 'OSVersion' | 'publicationDate' | 'subtitle' | 'type'
> {
  const computedStatus = isEqual(enumVersionPublicationStatus.PUBLISHED, status)
    ? enumVersionPublicationStatus.PUBLISHED.toLowerCase()
    : enumVersionPublicationStatus.DEPRECATED.toLowerCase();
  const computedCreationDate = toIsoStringIfDate(creationDate);
  return {
    title: toString(name),
    status: { label: computedStatus, type: computedStatus },
    assets,
    longDescription: toString(longDescription),
    shortDescription: toString(shortDescription),
    deviceFamilies: toArray(compatibleDeviceFamilyNames),
    creationDate: computedCreationDate,
    id: toString(id),
    systemPackageVersionIds: systemPackageVersions.reduce(
      (acc, version) => [...acc, ...(version.systemPackageVersionId ? [version.systemPackageVersionId] : [])],
      [] as string[],
    ),
  };
}

export function mapComponentVersionDependencyMetadataApiToVersionDTO(
  data: ComponentVersionDependencyMetadataApi[],
): VersionDTO {
  const firstName = data?.[0]?.name;
  return {
    name: toString(firstName),
    version: toArray(data.map(({ versionNumber }) => toString(versionNumber))),
  };
}
export function mapBffSystemPackageVersionById({
  compatibleOsVersions,
}: BffSystemPackageVersionResourceReadV2Api): BffSystemPackageVersionByIdFront {
  return {
    OSVersion: mapComponentVersionDependencyMetadataApiToVersionDTO(compatibleOsVersions),
  };
}
